import fly from '../fly'


export const login = (params) => {
  return fly.post("/operator/login",params)
}
